

<!-- GRID DE PROMOS -->
<div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" *ngIf="!loading">

  <div 
    *ngFor="let promo of promos" 
    class="promo-card cursor-pointer"
    (click)="openPromo(promo)"
  >
      <span class="promo-title">{{ promo.titulo }}</span>
      <img [src]="promo.urlimg" [alt]="promo.titulo">
  </div>
  

</div>


<!-- ============= MODAL ============= -->
<div   *ngIf="selectedPromo"   class="modal-wrapper"  (click)="closePromo()"  >

  <div     class="modal-box"     (click)="$event.stopPropagation()"    >

      <img [src]="selectedPromo.urlimg" class="modal-img">

      <div class="modal-body">

        <h2 class="font-bold text-xl mb-1">{{ selectedPromo.titulo }}</h2>

        <p class="text-gray-700 text-sm mb-3">{{ selectedPromo.descripcion }}</p>

        <p class="font-semibold text-red-600">
          <ng-container *ngIf="selectedPromo.toDate; else permanente">
            Vigencia hasta: {{ selectedPromo.toDate }}
          </ng-container>

          <ng-template #permanente>
            Vigencia: Permanente
          </ng-template>
        </p>

      </div>
  </div>
</div>


<style>
  /* ================== CARDS ==================== */
.promo-card {
  position: relative;
  border-radius: 14px;
  overflow: hidden;
  background: white;
  box-shadow: 0 3px 10px rgba(0,0,0,0.1);
  transition: transform .25s ease;
}

.promo-card:hover {
  transform: scale(1.03);
}

.promo-card img {
  width: 100%;
  height: 220px;
  object-fit: cover;
  object-position: center;
  display: block;
}

.promo-title {
  position: absolute;
  bottom: 10px;
  left: 10px;
  background: #ffffffdd;
  padding: 6px 10px;
  font-weight: bold;
  border-radius: 8px;
}


/* ================== MODAL ==================== */
.modal-wrapper {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.65);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
  padding: 20px;
}

.modal-box {
  width: 95%;
  max-width: 520px;
  background: white;
  border-radius: 16px;
  overflow: hidden;
  animation: modalIn .25s ease;
  box-shadow: 0 6px 20px rgba(0,0,0,0.25);
}

.modal-img {
  width: 100%;
  height: 240px;
  object-fit: cover;
}

.modal-body {
  padding: 18px 24px;
}


/* Animación suave */
@keyframes modalIn {
  from {
    opacity: 0;
    transform: translateY(20px) scale(.96);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

</style>
